import type { ReactNode } from "react";
import { spaceSubscribeGateLayoutCssVars } from "../../platform_spaces/space/Config";
import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import "../../platform_spaces/space/SpaceStyle.css";

type Props = {
  row: MembershipProduct;
  children: ReactNode;
};

/** 产品未开通：海报 + 订阅 CTA 槽位（平台站与独立站共用布局） */
export function ProductSubscribeGate(props: Props): JSX.Element {
  const { row, children } = props;
  const webPosterSrc =
    (row.webPurchasePosterUrl ?? "").trim() ||
    (row.mobilePurchasePosterUrl ?? "").trim();
  return (
    <div
      className="space-access-gate space-access-gate--poster"
      aria-label="会员开通引导"
      style={spaceSubscribeGateLayoutCssVars()}
    >
      <div className="space-access-gate__inner space-access-gate__inner--poster">
        {webPosterSrc ? (
          <div className="space-access-gate__poster-wrap">
            <img src={webPosterSrc} alt="" className="space-access-gate__poster-img" />
            <div className="space-access-gate__poster-shade" aria-hidden />
            <div className="space-access-gate__poster-cta">{children}</div>
          </div>
        ) : (
          <div className="space-access-gate__poster-cta space-access-gate__poster-cta--standalone">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
